import { render } from "./TandartsBoxtel.vue?vue&type=template&id=dd8a87e4&scoped=true"
import script from "./TandartsBoxtel.vue?vue&type=script&lang=js"
export * from "./TandartsBoxtel.vue?vue&type=script&lang=js"

import "./TandartsBoxtel.vue?vue&type=style&index=0&id=dd8a87e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8a87e4"]])

export default __exports__